import { useContext } from "react";
import { WorkshopContext } from "./workshopContextValue";

export function useWorkshop() {
  return useContext(WorkshopContext);
}
